/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart--multitype_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart--bar_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-bar-horizontal_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-column-stacked_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-bar-stacked_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart--line_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-area_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-point_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-marimekko_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart--treemap_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-heat-map_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-packed-bubble_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-hierarchical-packed-bubble_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/table_24',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-waterfall_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/box-plot_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/radar_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-bullet_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart--bubble_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-crosstab_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-data-player_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/map_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-composite_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/list_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/dropdown-list_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/earth--filled_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-network_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart--pie_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-radial_24',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart--scatter_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/spiral_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-summary_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-word-cloud_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/complex-calendar-heat-map_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-driver-analysis_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/complex-hierarchy-pie_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-sunburst_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-decision-tree_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/chart-summary-kpi_32'
], (
	change_visualization_32,
	complex_column_chart_32,
	complex_bar_32,
	complex_column_chart_stacked_32,
	complex_bar_stacked_32,
	complex_line_32,
	complex_area_32,
	complex_point_32,
	complex_marimekko_32,
	complex_tree_map_32,
	complex_heat_map_32,
	complex_packed_bubble_32,
	complex_hierarchical_packed_bubble_32,
	complex_table_32,
	complex_waterfall_32,
	complex_boxplot_32,
	complex_radar_32,
	complex_bullet_32,
	complex_bubble_32,
	complex_crosstab_32,
	complex_data_player_32,
	complex_map_legacy_32,
	complex_combo_32,
	complex_hierarchy_32,
	complex_dropdown_32,
	complex_map_chart_32,
	complex_network_32,
	complex_pie_32,
	complex_radial_32,
	complex_scatter_32,
	complex_spiral_driver_32,
	complex_summary_32,
	complex_word_cloud_32,
	complex_calendar_heat_map_32,
	complex_driver_analysis_32,
	complex_hierarchy_pie_32,
	complex_tree_sunburst_32,
	decision_tree_32,
	complex_kpi_summary_32
) => {

	/*
	* The following allows us to map a vis id to the graphic resources.
	*/
	return {
		graphicsList: () => {
			return [
				{
					id: 'visualizations-changeVisualization',
					icon: change_visualization_32
				}, {
					id: 'visualizations-column',
					icon: complex_column_chart_32
				}, {
					id: 'visualizations-bar',
					icon: complex_bar_32
				}, {
					id: 'visualizations-stackedcolumn',
					icon: complex_column_chart_stacked_32
				}, {
					id: 'visualizations-stackedbar',
					icon: complex_bar_stacked_32
				}, {
					id: 'visualizations-line',
					icon: complex_line_32
				}, {
					id: 'visualizations-area',
					icon: complex_area_32
				}, {
					id: 'visualizations-point',
					icon: complex_point_32
				}, {
					id: 'visualizations-marimekko',
					icon: complex_marimekko_32
				}, {
					id: 'visualizations-treemap',
					icon: complex_tree_map_32
				}, {
					id: 'visualizations-heatmap',
					icon: complex_heat_map_32
				}, {
					id: 'visualizations-packedbubble',
					icon: complex_packed_bubble_32
				}, {
					id: 'visualizations-hierarchicalpackedbubble',
					icon: complex_hierarchical_packed_bubble_32
				}, {
					id: 'visualizations-table',
					icon: complex_table_32
				},{
					id: 'visualizations-waterfall',
					icon: complex_waterfall_32
				},{
					id: 'visualizations-boxplot',
					icon: complex_boxplot_32
				}, {
					id: 'visualizations-radar',
					icon: complex_radar_32
				}, {
					id: 'visualizations-bullet',
					icon: complex_bullet_32
				}, {
					id: 'visualizations-bubble',
					icon: complex_bubble_32
				}, {
					id: 'visualizations-crosstab',
					icon: complex_crosstab_32
				}, {
					id: 'visualizations-crosstab',
					icon: complex_crosstab_32
				}, {
					id: 'visualizations-dataplayer',
					icon: complex_data_player_32
				}, {
					id: 'visualizations-dataplayer',
					icon: complex_data_player_32
				}, {
					id: 'visualizations-maplegacy',
					icon: complex_map_legacy_32
				}, {
					id: 'visualizations-combo',
					icon: complex_combo_32
				}, {
					id: 'visualizations-hierarchy',
					icon: complex_hierarchy_32
				}, {
					id: 'visualizations-dropdown',
					icon: complex_dropdown_32
				}, {
					id: 'visualizations-map',
					icon: complex_map_chart_32
				}, {
					id: 'visualizations-network',
					icon: complex_network_32
				}, {
					id: 'visualizations-pie',
					icon: complex_pie_32
				}, {
					id: 'visualizations-radial',
					icon: complex_radial_32
				}, {
					id: 'visualizations-scatter',
					icon: complex_scatter_32
				}, {
					id: 'visualizations-spiral',
					icon: complex_spiral_driver_32
				}, {
					id: 'visualizations-kpi',
					icon: complex_kpi_summary_32
				}, {
					id: 'visualizations-summary',
					icon:  complex_summary_32
				}, {
					id: 'visualizations-wordcloud',
					icon: complex_word_cloud_32
				}, {
					id: 'visualizations-calendarheatmap',
					icon: complex_calendar_heat_map_32
				}, {
					id: 'visualizations-comet',
					icon: complex_driver_analysis_32
				}, {
					id: 'visualizations-hierarchicalpie',
					icon: complex_hierarchy_pie_32
				}, {
					id: 'visualizations-sunburst',
					icon: complex_tree_sunburst_32
				}, {
					id: 'visualizations-decisiontree',
					icon: decision_tree_32
				}
			];
		}
	};
});
